import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import initApp from 'utils/functions/init';
import { Contexts } from 'constants/context';
// eslint-disable-next-line max-len
import SurgicalPriceListsContainer from 'modules/categories/surgical/container/SurgicalPriceListsContainer';
import { useParams } from 'react-router-dom';
import { fetchSelectedealthPlan } from 'modules/healthPlans/healthPlansSlice';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const SurgicalPriceListsPage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const { healthPlanId } = useParams();

  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    initApp(Contexts.Surgical);
    dispatch(fetchSelectedealthPlan(healthPlanId));
  }, [dispatch]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <SurgicalPriceListsContainer />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

SurgicalPriceListsPage.propTypes = {};

SurgicalPriceListsPage.defaultProps = {};

export default SurgicalPriceListsPage;
